export default "__VITE_ASSET__22d68d59__"